import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import BudgetBootstrapPage from "./pages/BudgetBootstrapPage";
import BudgetEntryPage from "./pages/BudgetEntryPage";
import RestoreBackupPage from "./pages/RestoreBackupPage";
import SetupPage from "./pages/SetupPage";
import BudgetDashboardPage from "./pages/BudgetDashboardPage";
import BudgetModuleResolverPage from "./pages/BudgetModuleResolverPage";
import BudgetModuleDepartmentsPage from "./pages/BudgetModuleDepartmentsPage";
import BudgetModulePlannerPage from "./pages/BudgetModulePlannerPage";
import BudgetModuleChangeRequestsPage from "./pages/BudgetModuleChangeRequestsPage";
import LegacyWorkspaceRedirectPage from "./pages/LegacyWorkspaceRedirectPage";
import ImportBudgetPage from "./pages/ImportBudgetPage";
import BudgetModuleMappingPage from "./pages/BudgetModuleMappingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import MainUserRoute from "./components/MainUserRoute";
import { BUDGET_MODULE_PATHS } from "./constants/budgetModule";

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/setup"
        element={
          <ProtectedRoute>
            <SetupPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-entry"
        element={
          <ProtectedRoute>
            <BudgetEntryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/restore-backup"
        element={
          <ProtectedRoute>
            <MainUserRoute>
              <RestoreBackupPage />
            </MainUserRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/bootstrap"
        element={
          <ProtectedRoute>
            <MainUserRoute>
              <BudgetBootstrapPage />
            </MainUserRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Navigate to={BUDGET_MODULE_PATHS.dashboard} replace />
          </ProtectedRoute>
        }
      />
      <Route
        path="/landing-option"
        element={
          <ProtectedRoute>
            <Navigate to="/budget-entry" replace />
          </ProtectedRoute>
        }
      />
      <Route
        path="/import-budget"
        element={
          <ProtectedRoute>
            <MainUserRoute>
              <ImportBudgetPage />
            </MainUserRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:year"
        element={
          <ProtectedRoute>
            <LegacyWorkspaceRedirectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-planner"
        element={
          <ProtectedRoute>
            <Navigate to={BUDGET_MODULE_PATHS.resolver} replace />
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-module"
        element={
          <ProtectedRoute>
            <BudgetModuleResolverPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-module/dashboard"
        element={
          <ProtectedRoute>
            <MainUserRoute>
              <BudgetDashboardPage />
            </MainUserRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-module/mapping"
        element={
          <ProtectedRoute>
            <MainUserRoute>
              <BudgetModuleMappingPage />
            </MainUserRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-module/departments"
        element={
          <ProtectedRoute>
            <MainUserRoute>
              <BudgetModuleDepartmentsPage />
            </MainUserRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-module/planner"
        element={
          <ProtectedRoute>
            <BudgetModulePlannerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/budget-module/change-requests"
        element={
          <ProtectedRoute>
            <BudgetModuleChangeRequestsPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/budget-entry" replace />} />
    </Routes>
  );
};

export default App;
